// extracted by mini-css-extract-plugin
module.exports = {"connexion":"Connexion_connexion__3lSpa","body":"Connexion_body__2ry5h","column":"Connexion_column__1rt7s"};